<template>
  <div class="invite-friends-wrapper">
    <div class="header-box">
      <PageMbHeader
        :title="$t('邀请好友')"
        :iconClass="isH5 ? 'icon-linetype_back_iOS' : 'icon-outline_close'"
        :transShow="false"
        :transOpen="false"
        @icon-click="close"
      />
    </div>
    <div class="scroll-box-wrapper">
      <div class="banners-wrapper">
        <!-- 轮播 -->
        <Banner
          :items="bannerList"
        />
        <div class="rewards-open" @click="openMyRewards">{{ $t('我的奖励') }}</div>
      </div>
      <div class="content-box">
        <Rewards
          :isOpen="true"
          :rewardedAmount="rewardedAmount"
          :pendingAmount="pendingAmount"
          @open-my-rewards="openMyRewards"
        />
        <div class="media-share-box">
          <div class="media-share-item">
            <p class="title">{{ $t('通过SNS邀请') }}</p>
            <p class="status-txt" v-show="shareUrlCopied === 'code'">
              <i class="el-icon-check"></i>
              {{ $t('复制成功') }}
            </p>
            <div class="pc-content">
              <p class="content-code content-pc">{{ recommendCode }}</p>
              <el-button class="copy-btn" outline @click="copyText(recommendCode, 'code')">{{
                  $t('FoodOpC_backend_Copy_HxOc')
                }}
              </el-button>
              <p class="copy-btn-h5" @click="copyText(recommendCode, 'code')"><i class="el-icon-document-copy"></i></p>
            </div>
          </div>
          <div class="media-share-item" v-if="shareUrl">
            <p class="title">{{ $t('将优惠分享到') }}</p>
            <p class="status-txt" v-show="shareUrlCopied === 'shareUrl'">
              <i class="el-icon-check"></i>
              {{ $t('复制成功') }}
            </p>
            <div class="pc-content">
              <!-- $t('FoodC_referral_Copy_link_kCti') -->
              <p class="content-url content-pc">{{ shareUrl }}</p>
              <el-button class="copy-btn" outline @click="copyText(shareUrl, 'shareUrl')">{{
                  $t('FoodOpC_backend_Copy_HxOc')
                }}
              </el-button>
              <p class="copy-btn-h5" @click="shareH5(shareUrl, 'shareUrl')"><i class="el-icon-document-copy"></i></p>
            </div>
          </div>
        </div>
        <div class="rule-desc-box">
          <div class="rule-title">
            <span class="line-left"></span>
            <span class="title">{{ $t('规则详情') }}</span>
            <span class="line-right"></span>
          </div>
          <p
            class="desc-item"
            v-for="(rule, rIndex) in ruleList"
            :key="'rule' + rIndex"
            v-text="rIndex + 1 + '.' + rule"
          ></p>
        </div>
      </div>
    </div>
    <MyRewardsDialog
      v-model="myRewardsShow"
      :activityId="activityId"
      :code="recommendCode"
    />
    <input id="copy-text-only" readonly type="text">
  </div>
</template>

<script>
import api from '@/api';
import { mapState } from 'vuex';
import { ruleCountryList } from './rule.js';
import { getLocale } from '@/utils/locale';
import { getUrlOrigin } from '@/utils/baseUtil';
import { getLocalStorage } from '@/utils/localStorage';

import Banner from './banner.vue';
import Rewards from './rewards.vue';
import PageMbHeader from '@/components/PageMbHeader';
import MyRewardsDialog from '@/components/MyRewards/dialog.vue';

export default {
  name: 'InviteFriedns',
  components: {
    Banner,
    Rewards,
    PageMbHeader,
    MyRewardsDialog,
  },
  data() {
    return {
      locale: getLocale(),
      myRewardsShow: false,
      recommendPage: {},
      bannerList: [],
      recommendCode: '',
      activityId: 0,
      rewardedAmount: 0,
      pendingAmount: 0,
      shareUrl: '', // 分享 打开领取券的页面地址
      shareOriginUrl: '',
      ruleList: ruleCountryList['JP'],
      shareUrlCopied: '',
    };
  },
  computed: {
    ...mapState('common', ['isH5']),
    // actTimeDesc() {
    //   return `[${this.recommendPage.startTimeDisplay}-${this.recommendPage.startTimeDisplay}]`
    // }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      api.getRecActivity({
        activityType: 'CC',
      }).then((data) => {
        if (data) {
          let recommendPage = data.recommendPage;
          this.activityId = data.activityID;
          this.recommendPage = recommendPage
          this.recommendCode = data.recommendCode;
          this.bannerList = recommendPage.focusImg.list || [];
          this.rewardedAmount = data?.rewardedAmountSplit?.display || 0;
          this.pendingAmount = data?.pendingAmountSplit?.display || 0;
          // 需要转短链 https://www.didi-food.com
          let url = `https://www.didi-food.com/${this.locale}/food/feed/?rsc_media=Web_referral&activityType=CC&res_code=${this.recommendCode}&activityId=${this.activityId}&pl=${encodeURIComponent(this.$route.query.pl)}`
          this.shareOriginUrl = url
          this.getShortChain(url).then((url) => {
            this.shareUrl = url
          })
        }
        this.swTrack()
      }).catch((err) => {
        // err
      });
    },
    async getShortChain(url) {
      // 99 的分享链接 为 short_url_99 字段
      let shortUrl = await api.getShortChain({
        url: url,
        token: getLocalStorage('ticket'),
      });
      return shortUrl.short_url;
    },
    close() {
      this.$emit('icon-click');
    },
    openMyRewards() {
      // 打开 我的奖励
      if (this.isH5) {
        this.$router.push({
          path: '/user/rewards/',
          query: {
            code: this.recommendCode,
            activityId: this.activityId,
          },
        });
      } else {
        this.myRewardsShow = true;
      }
      this.$trackEvent({
        eventId: 'sailing_c_x_invitedetail_common_sw',
        eventLabel: '用户查看奖励详细信息页面展示',
        attrs: {
          activity_id: this.activityId,
          rewarded_num: this.rewardedAmount,
          pending_num: this.pendingAmount,
        },
      });
    },
    shareH5(shareUrl, type) {
      let title = this.recommendPage?.share?.default?.title
      if (navigator.share) {
        navigator.share({
          title: title,
          url: shareUrl,
          text: title,
        }).then(() => {
          console.log('Thanks for sharing!');
        })
        .catch(console.error);
      } else {
        // Fallback
        this.copyText(shareUrl, type)
      }
      this.$trackEvent({
        eventId: 'sailing_c_x_invitation_copy_ck',
        eventLabel: '点击链接的复制按钮',
        attrs: {
          activity_id: this.activityId,
          invite_link: this.shareOriginUrl
        },
      });
    },
    copyText(text, type) {
      let input = document.getElementById('copy-text-only'); // 获取隐藏input的dom
      input.value = text; // 修改文本框的内容
      input.select(); // 选中文本
      document.execCommand('copy'); // 执行浏览器复制命令
      if (!this.isH5) {
        this.shareUrlCopied = type
        setTimeout(() => {
          this.shareUrlCopied = ''
        }, 1000);
      } else {
        this.$utils.infoToast(this.$t('复制成功'))
      }
      if (type === 'code') {
        this.$trackEvent({
          eventId: 'sailing_c_x_invitation_copy_link_ck',
          eventLabel: '点击你的邀请码旁边的复制按钮',
          attrs: {
            activity_id: this.activityId,
            invite_code: this.recommendCode,
          },
        });
      }
    },
    swTrack() {
      this.$trackEvent({
        eventId: 'sailing_c_x_invitation_common_sw',
        eventLabel: '推荐有奖页面展示',
        attrs: {
          invite_code: this.recommendCode,
          activity_id: this.activityId,
          rewarded: this.rewardedAmount,
          pending: this.pendingAmount,
        },
      });
    }
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
